import React from 'react';
import Paper from 'material-ui/Paper';
import RaisedButton from 'material-ui/RaisedButton';
import TextField from 'material-ui/TextField';
import Flipper from './Flipper'
import emailValidator from 'email-validator';
import userContext from '../services/userContext';
import OverlayController from './overlay/OverlayController';
import { browserHistory } from 'react-router'

export default class LoginPanel extends React.Component {

    static muiName = 'Paper';

    static Modes = {
        Login: "login",
        Register: "register",
        ForgotPassword: "forgotPassword",
        ForgotPasswordEmailSent: "forgotPasswordEmailSent",
        ResetPassword: "resetPassword"
    };

    paperStyle = {
        display: 'block',
        margin: "50px auto",
        padding: 20,
        width: 500,
        textAlign: 'center',
    };

    buttonStyle = {
        display: "block",
        margin: "20px auto 0",
        width: 200
    };

    constructor(props) {
        super(props);

        // if (userContext.isLoggedIn()) {
        //     return null;
        // }

        this.didClickChangeToRegister = this.didClickChangeToRegister.bind(this);
        this.didClickChangeToLogin = this.didClickChangeToLogin.bind(this);
        this.didClickForgotPassword = this.didClickForgotPassword.bind(this);
        this.didChangeEmail = this.didChangeEmail.bind(this);
        this.didChangePassword = this.didChangePassword.bind(this);
        this.didChangePasswordValidation = this.didChangePasswordValidation.bind(this);
        this.didSubmit = this.didSubmit.bind(this);

        this.email = null;
        this.password = null;
        this.passwordValidation = null;

        if (this.props.params && this.props.params.resetPasswordToken) {
            this.resetPasswordToken = this.props.params.resetPasswordToken;
        }

        let mode = LoginPanel.Modes.Login;
        if (this.props.route && this.props.route.mode) {
            mode = this.props.route.mode;
        }

        this.isEmailValid = false;
        this.isPasswordValid = false;

        this.flipper = null;
        this.state = {
            mode: mode,
            isValid: false,
            errorMessage: null
        };
    }

    didClickChangeToRegister(event) {
        event.preventDefault();
        this.passwordValidation = null;
        this.flipper.flip(() => {
            this.setMode(LoginPanel.Modes.Register);
        }, () => {
            browserHistory.push('/register');
        });
    }

    didClickChangeToLogin(event) {
        event.preventDefault();
        this.flipper.flip(() => {
            this.setMode(LoginPanel.Modes.Login);
        }, () => {
            browserHistory.push('/login');
        });
    }

    didClickForgotPassword(event) {
        event.preventDefault();
        this.password = null;
        this.passwordValidation = null;
        this.isPasswordValid = false;
        this.flipper.flip(() => {
            this.setMode(LoginPanel.Modes.ForgotPassword);
        }, () => {
            browserHistory.push('/forgotPassword');
        });
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.route && nextProps.route.mode !== this.state.mode) {
            this.flipper.flip(() => {
                this.setMode(nextProps.route.mode);
            });
        }
    }

    setMode(mode) {
        this.setState({
            mode: mode,
            isValid: this.isValidForMode(mode),
            errorMessage: null
        });
    }

    didChangeEmail(event) {
        this.email = event.target.value;
        this.isEmailValid = emailValidator.validate(this.email);
        this.updateIsStateIfNeeded();
    }

    didChangePassword(event) {
        this.password = event.target.value;
        this.isPasswordValid = this.validatePassword();
        this.updateIsStateIfNeeded();
    }

    didChangePasswordValidation(event) {
        this.passwordValidation = event.target.value;
        this.updateIsStateIfNeeded();
    }

    validatePassword() {
        let longEnough = this.password.length >= 4;
        // let hasLowercaseChar = /[a-z]/.test(this.password);
        // let hasUppercaseChar = /[A-Z]/.test(this.password);
        // let hasNumericChar = /[0-9]/.test(this.password);
        return longEnough; //&& hasLowercaseChar && hasUppercaseChar && hasNumericChar;
    }

    updateIsStateIfNeeded() {
        let isValid = this.isValidForMode(this.state.mode);
        if (isValid !== this.state.isValid || this.state.errorMessage) {
            this.setState({
                isValid: isValid,
                errorMessage: null
            });
        }
    }

    isValidForMode(mode) {
        switch (mode) {
            case LoginPanel.Modes.Login:
                return this.isEmailValid && this.password;
            case LoginPanel.Modes.Register:
                return this.isEmailValid && this.isPasswordValid && this.password === this.passwordValidation;
            case LoginPanel.Modes.ForgotPassword:
                return this.isEmailValid;
            case LoginPanel.Modes.ResetPassword:
                return this.isPasswordValid && this.password === this.passwordValidation;
            default:
                throw new Error("Illegal LoginPanel mode: " + mode);
        }
    }

    didSubmit(event) {
        event.preventDefault();
        OverlayController.showActivityIndicator();
        let loginPromise = null;
        let finalPromise = null;
        switch (this.state.mode) {
            case LoginPanel.Modes.Login:
                loginPromise = userContext.login(this.email, this.password);
                break;
            case LoginPanel.Modes.Register:
                loginPromise = userContext.register(this.email, this.password);
                break;
            case LoginPanel.Modes.ForgotPassword:
                finalPromise = userContext.forgotPassword(this.email).then(() => {
                    this.email = null;
                    this.isEmailValid = null;
                    this.setState({
                        mode: LoginPanel.Modes.ForgotPasswordEmailSent,
                        isValid: false,
                        errorMessage: null
                    });
                });
                break;
            case LoginPanel.Modes.ResetPassword:
                loginPromise = userContext.resetPassword(this.password, this.resetPasswordToken);
                break;
            default:
                throw new Error("Illegal LoginPanel mode: " + this.state.mode);
        }
        if (loginPromise) {
            finalPromise = loginPromise.then(() => {
                browserHistory.push('/');
            });
        }
        finalPromise.then(() => {
            OverlayController.hideActivityIndicator();
        }, error => {
            OverlayController.hideActivityIndicator();
            this.setState({
                errorMessage: error.message
            });
        });
    }

    render() {
        let title;
        let buttonLabel;
        let passwordValidationField = null;
        let changeMode = null;
        let forgotPassword = null;
        let errorMessage = null;
        let submitButton = null;
        let emailField = <TextField hintText="email address" onChange={this.didChangeEmail} />;
        let passwordField = <TextField hintText="password" type="password" onChange={this.didChangePassword} />;

        switch (this.state.mode) {
            case LoginPanel.Modes.Login:
                title = <p>Enter your email address and password to login</p>;
                buttonLabel = "Login";
                changeMode = <p>Don't have an account? Click <a href="#" onClick={this.didClickChangeToRegister}>here</a> to register</p>;
                forgotPassword = <p><a href="#" onClick={this.didClickForgotPassword}>Forgot password?</a></p>;
                break;
            case LoginPanel.Modes.Register:
                title = <p>Enter your email address and password to register</p>;
                buttonLabel = "Register";
                passwordValidationField = <TextField hintText="verify password" type="password" onChange={this.didChangePasswordValidation} />;
                changeMode = <p>Already have an account? Click <a href="#" onClick={this.didClickChangeToLogin}>here</a> to login</p>;
                break;
            case LoginPanel.Modes.ForgotPassword:
                title = <p>Enter your email address to receive instructions to reset password</p>;
                buttonLabel = "Send Email";
                changeMode = <p>Click <a href="#" onClick={this.didClickChangeToLogin}>here</a> to login</p>;
                passwordField = null;
                break;
            case LoginPanel.Modes.ForgotPasswordEmailSent:
                title = <p>Check your email for further instructions</p>;
                changeMode = <p>Click <a href="#" onClick={this.didClickChangeToLogin}>here</a> to login</p>;
                emailField = null;
                passwordField = null;
                break;
            case LoginPanel.Modes.ResetPassword:
                title = <p>Enter new password</p>;
                buttonLabel = "Reset Password";
                passwordValidationField = <TextField hintText="verify password" type="password" onChange={this.didChangePasswordValidation} />;
                emailField = null;
                break;
            default:
                throw new Error("Illegal LoginPanel mode: " + this.state.mode);
        }

        if (buttonLabel) {
            submitButton = <RaisedButton type="submit" label={buttonLabel} primary={true} style={this.buttonStyle} disabled={!this.state.isValid} />;
        }

        if (this.state.errorMessage) {
            errorMessage = <p style={{color: "red"}}>{this.state.errorMessage}</p>;
        }

        return (
            <Flipper style={{width: "500px", margin: "auto"}} ref={(flipper) => { this.flipper = flipper; }}>
                <Paper className="login-panel" style={this.paperStyle} zDepth={2}>
                    <form onSubmit={this.didSubmit}>
                        {title}
                        {errorMessage}
                        {emailField}
                        {passwordField}
                        {passwordValidationField}
                        {submitButton}
                        {changeMode}
                        {forgotPassword}
                    </form>
                </Paper>
            </Flipper>
        )
    }

};



// WEBPACK FOOTER //
// ./src/components/LoginPanel.js